import FullIndex from './full.vue';
import MobFullIndex from './mob-full.vue';

export const componentMap = {
    full: FullIndex,
    'mob-full': MobFullIndex
};